import { useTranslation } from 'react-i18next';
import Position from '../../../../models/Position';

export const getFirstActiveJobDate = ({ status }) => {
    if (!status) {
        return null;
    }

    let firstActiveDate = status.timestamp;
    const history = status.history || [];

    for (let i = 0; i < history.length; i++) {
        if (history[i].status === 'Active') {
            firstActiveDate = history[i].timestamp;
        }
    }

    return firstActiveDate;
};

export const getFormattedStringDate = (dateToFormat) => {
    const date = new Date(dateToFormat);

    if (date.toString() === 'Invalid Date') {
        return dateToFormat;
    }

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });

    return dateFormatter.format(date);
};

export const getFormattedDate = (dateToFormat) => {
    const { t } = useTranslation();

    const nowDate = new Date();
    const date = new Date(dateToFormat);

    if (date.toString() === 'Invalid Date') {
        return dateToFormat;
    }

    const stringDate = getFormattedStringDate(dateToFormat);
    let delta = (nowDate - date) / 1000;

    if (delta < 60) {
        return t('JUST_NOW');
    }

    const years = Math.floor(delta / 31536000);
    delta -= years * 31536000;

    if (years) {
        return `${stringDate} (${years} years ago)`;
    }
    const months = Math.floor(delta / 2592000);
    delta -= months * 2592000;

    if (months) {
        return `${stringDate} (${months} month ago)`;
    }

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    if (days) {
        return `${stringDate} (${days} days ago)`;
    }

    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    if (hours) {
        return `${stringDate} (${hours} hours ago)`;
    }

    const minutes = Math.floor(delta / 60) % 60;

    if (minutes === 0) {
        return t('JUST_NOW');
    }

    return `${stringDate} (${minutes} minutes ago)`;
};

export const getFormattedLocationsCollection = (position) => Position.getFormattedLocations(position);

export const getFormattedPositionInfo = (
    position,
    t,
    isListView,
    employer,
    showCurrentStatusTimestamp,
) => Position.getFormattedPositionInfo(position, t, isListView, employer, showCurrentStatusTimestamp);

export const getLocationsTooltip = (position) => Position.getLocationsTooltip(position);
